import React from 'react'

import { Form, Select, Typography } from 'antd'

import { SelectOptionsField } from '../../../../types/blueprint'

type Props = {
  value: string
  onChange: (value: string) => void
}

export const DefaultOptionInput: React.FC<Props> = ({ value, onChange }) => {
  const handleChange = (selected: string) => {
    onChange(selected)
  }

  // bit of backwards compatibility with legacy code where default was an object
  const formattedValue =
    typeof value === 'object' ? (value ? value['label'] : null) : value

  return (
    <Form.Item dependencies={['options']} noStyle>
      {({ getFieldValue }) => {
        const options = getFieldValue('options') as SelectOptionsField[]
        if (!options || !options.length)
          return (
            <Typography.Text type="secondary">
              Add some options above
            </Typography.Text>
          )

        return (
          <Select
            allowClear
            defaultValue={formattedValue}
            onChange={handleChange}
          >
            {options.map((o) => (
              <Select.Option key={o.label} value={o.label}>
                {o.label}
              </Select.Option>
            ))}
          </Select>
        )
      }}
    </Form.Item>
  )
}
